import React, { memo, useCallback } from 'react';
import styles from './AttachedCommonFiles.module.scss';
import { Icon } from 'antd';
import { formatBytes } from './utils/formatBytes';
import { createURL } from '../AttachedImages/utils/createURL';
import { downloadAttachedFile } from '../../../../../actions/commentsActions/documentsCommentsActions/documentsCommentsActions';
import { useDispatch, useSelector } from 'react-redux';

const AttachedCommonFiles = ({ attachedFiles, deleteAttachedCommonFile }) => {
  const dispatch = useDispatch();
  const editedCommentId = useSelector(
    (state) => state.commentsChatStore.editedComment.id
  );
  const downloadFile = useCallback(
    (file) => {
      if (file.fileName) {
        dispatch(
          downloadAttachedFile(file.fileName, file.name, editedCommentId)
        );
      } else {
        const url = createURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    },
    [editedCommentId]
  );

  return (
    <>
      {attachedFiles.length ? (
        <div className={styles.attachedFiles}>
          {attachedFiles.map((file, index) => (
            <div
              key={`common-file-${index}-${file.name}`}
              className={styles.attachedFile}
            >
              <div className={styles.attachedFileIcon}>
                <Icon type={'paper-clip'} />
              </div>
              <div
                className={styles.fileNameAndSize}
                onClick={() => downloadFile(file)}
              >
                <div>{file.name}</div>
                <div className={styles.fileSize}>
                  {file.size && formatBytes(file.size, 1)}
                </div>
              </div>

              <div
                className={styles.deleteAttachedFile}
                onClick={() => deleteAttachedCommonFile(index)}
              >
                <Icon
                  type="close-circle"
                  theme="twoTone"
                  twoToneColor={'#c5c5c5'}
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default memo(AttachedCommonFiles);
